<div class="soft-ds-date-range-picker-modal-shell flex flex-col mt-4 sm:mt-0 px-4 sm:px-0">
  <soft-ds-date-range-picker
    class="date-picker"
    [value]="value()"
    (valueChange)="onValueChange($event)"
    [shortcuts]="shortcuts()"
    [startField]="startField()"
    [selectionMode]="selectionMode()"
    [firstSelectDay]="firstSelectDay()"
    [selectSize]="selectSize()"
    #picker
  >
  </soft-ds-date-range-picker>
</div>
